import React, { useCallback, useEffect, useContext, useRef, useState } from "react";
import { Context } from "./Reducers/Store";
import { Routes, Route, useLocation, Navigate, useNavigate } from "react-router-dom";

import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard.js";
import UsuarioList from "./pages/Usuarios/UsuarioList.js";
import UsuarioForm from "./pages/Usuarios/UsuarioForm.js";
import ClienteList from "./pages/Clientes/ClienteList.js";
import ClienteForm from "./pages/Clientes/ClienteForm.js";

import ContaList from "./pages/Contas/ContaList.js";
import ContaForm from "./pages/Contas/ContaForm.js";

import GrupoList from "./pages/Grupos/GrupoList.js";
import GrupoForm from "./pages/Grupos/GrupoForm.js";

import LinkExternoValidacao from "./pages/LinkExterno/LinkExternoValidacao.js";
import LinkExternoList from "./pages/LinkExterno/LinkExternoList.js";

import CertificadosList from "./pages/Certificados/CertificadosList.js";

import LayoutEmpty from "./pages/Layouts/LayoutEmpty.js";
import SmartRedirect from "./components/SmartRedirect/index.js";
import RequireAuth from "./RequireAuth.js";
import LayoutDashboard from "./pages/Layouts/LayoutDashboard.js";
import PrimeiroAcesso from "./pages/PrimeiroAcesso/PrimeiroAcesso.js";
import EsqueciSenha from "./pages/EsqueciSenha/EsqueciSenha.js";
import ResetSenha from "./pages/ResetSenha/ResetSenha.js";
import AlterarSenha from "./pages/AlterarSenha/AlterarSenha.js";

export default function App() {
	const firstLoad = useRef(true);
	const navigate = useNavigate();
	const location = useLocation();
	const [state, dispatch] = useContext(Context);

  	useEffect(() => {
		const jwt = localStorage.getItem("jwt");
		const refreshToken = localStorage.getItem("refreshToken");
		if (jwt)
			dispatch([{ type: "SET_LOGGED", payload: { success: true, data: { accessToken: jwt, refreshToken: refreshToken } } }, { type: "SET_READY", payload: true }]);
		else
			dispatch([{ type: "SET_LOGGED", payload: null }, { type: "SET_USER_PREFERENCES", payload: null }, { type: "SET_READY", payload: true }]);
	}, []);

	useEffect(() => {
	if (state.isLogged) {
		if (firstLoad.current) {
		firstLoad.current = false;
		// Só redireciona para SmartRedirect se estiver vindo do login
		if (location?.pathname === "/login") {
			navigate("/", { state: { from: { pathname: "/dashboard" } } });
		}
		// Se já está em rota protegida, mantém onde está
		}
	}
	}, [state.isLogged]);

  return state.ready ? 
		<Routes>
			<Route element={<LayoutEmpty />}>
        		<Route path="/login" element={<Login />} />
				<Route path="/enviar-certificado/:codigo" element={<LinkExternoValidacao />} />
				<Route path="/primeiro-acesso/:token" element={<PrimeiroAcesso />} />
				<Route path="/esqueci-senha" element={<EsqueciSenha />} />
				<Route path="/reset-senha/:token" element={<ResetSenha />} />
			</Route>
      
			<Route element={<RequireAuth><LayoutDashboard /></RequireAuth>}>
				<Route path="/" element={<SmartRedirect />} />

				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/usuarios" element={<UsuarioList />} />
				<Route path="/usuarios/novo" element={<UsuarioForm />} />
				<Route path="/usuarios/:id" element={<UsuarioForm />} />
				<Route path="/alterar-senha" element={<AlterarSenha />} />

				<Route path="/clientes" element={<ClienteList />} />
				<Route path="/clientes/novo" element={<ClienteForm />} />
				<Route path="/clientes/:id" element={<ClienteForm />} />

				<Route path="/contas" element={<ContaList />} />
				<Route path="/contas/nova" element={<ContaForm />} />
				<Route path="/contas/:id" element={<ContaForm />} />

				<Route path="/clientes/:empresaId/links" element={<LinkExternoList />} />


				<Route path="/grupos" element={<GrupoList />} />
				<Route path="/grupos/novo" element={<GrupoForm />} />
				<Route path="/grupos/:id" element={<GrupoForm />} />

				<Route path="/certificados" element={<CertificadosList />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" />} />
    </Routes> : null;
}
